import PropTypes from 'prop-types';

export const SupportedLanguages = {
	ENGLISH: {
		key: 1000,
		code: 'en'
	},
	FRENCH: {
		key: 1002,
		code: 'fr'
	},
	SPANISH: {
		key: 1001,
		code: 'sp'
	}
};

export const TranslationObjectDefinition = PropTypes.shape({
	ids: PropTypes.arrayOf(PropTypes.string),
	coNum: PropTypes.number,
	baNum: PropTypes.number,
	baType: PropTypes.string,
	gdNum: PropTypes.number,
	language: PropTypes.oneOf(Object.values(SupportedLanguages).map(language => language.code))
});
